// ===========================================
// 中見出しのインタラクション
// ===========================================
export const markerSet = (area) => {
  const ttl = area.find('.c-blockHead__ttl'),
        txt = area.find('.c-blockHead__txt');
  let scroll = $(window).scrollTop();

  if( area.offset().top < scroll + $(window).height() - 200 ) {
    ttl.addClass('c-blockHead__ttl--markerOn');

    setTimeout(function () {
      ttl.addClass('c-blockHead__ttl--markerOff');
      ttl.addClass('c-blockHead__ttl--gTxtOn');

      setTimeout(function () {
        ttl.addClass('c-blockHead__ttl--gTxtOff');
      }, 200);
    }, 300);

    setTimeout(function () {
      txt.addClass('c-blockHead__txt--markerOn');

      setTimeout(function () {
        txt.addClass('c-blockHead__txt--markerOff');
        txt.addClass('c-blockHead__txt--gTxtOn');

        setTimeout(function () {
          txt.addClass('c-blockHead__txt--gTxtOff');
        }, 200);
      }, 300);
    }, 300);

    if( area.find('.c-blockHeadTxtMobile').not('.c-blockHeadTxtMobile--special').length ) {
      const txtMobile = area.find('.c-blockHeadTxtMobile');

      setTimeout(function () {
        txtMobile.addClass('c-blockHeadTxtMobile--markerOn');

        setTimeout(function () {
          txtMobile.addClass('c-blockHeadTxtMobile--markerOff');
          txtMobile.addClass('c-blockHeadTxtMobile--gTxtOn');

          setTimeout(function () {
            txtMobile.addClass('c-blockHeadTxtMobile--gTxtOff');
          }, 200);
        }, 300);
      }, 1100);
    }
  }
}